export default __webpack_public_path__ + "static/media/logo.d59ea6ba.svg";